import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { User } from 'firebase/auth';
import { FirebaseService } from './services/firebase/firebase.service';

export type AuthPipeGenerator = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => any;

export const loggedIn: any = (user: User) => !!user;

const retrieveUser = (firebase: FirebaseService): Promise<User> => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(null), 3000);
    const sub = firebase.auth.onAuthStateChanged((user) => {
      clearTimeout(timeout);
      sub();
      resolve(user);
    }, () => {
      clearTimeout(timeout);
      resolve(null);
    });
  });
};

export const angularFireAuthGuard: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const firebase = inject(FirebaseService);

  try {
    const authPipeFactory = next.data.authGuardPipe as AuthPipeGenerator || (() => loggedIn);
    const user = await retrieveUser(firebase);
    const can = authPipeFactory(next, state)(user);
    if (typeof can === 'boolean') {
      return can;
    } else if (Array.isArray(can)) {
      return router.createUrlTree(can);
    } else {
      return router.parseUrl(can);
    }
  } catch {
    return router.createUrlTree(['/login']);
  }
};

export const redirectUnauthorizedTo: (redirect: string|any[]) => any =
  (redirect) => (user: User) => loggedIn(user) || redirect;
export const redirectLoggedInTo: (redirect: string|any[]) => any =
  (redirect) => (user: User) => loggedIn(user) && redirect || true;
